import React from "react";
import Service from "../Items/Service";

const servicesData = [

    {
    id: 1,
    name: "Remote",
    content: "Seeking a dynamic and skilled developer? Look no further. With reliability, professionalism, and effective communication, I bring dedication and ease of collaboration to every project",
    icon: "icon-bubbles",
  },
  
  
  {
    id: 2,
    name: "Gigs",
    content: "Crafting visually stunning website that harmonize with your brand image effortlessly. Let's work together to build an online presence that reflects the essence of your business ",
    icon: "icon-chemistry",
  },
  {
    id: 3,
    name: "Freelance Collab",
    content: "Count me in for collaborative endeavors and adding value to exceptional project visions. Together, we can bring those ideas to life and make a difference ",
    icon: "icon-directions",
  },
  {
    id: 4,
    name: "Tailored Development",
    content: "Engineering solutions aligned with your goals, I guarantee code that's easy to update, with animated web pages and SEO optimization for digital prowess.",
    icon: "icon-note",
  },
    {
    id: 5,
    name: "Fullstack Development",
    content: "I’m the code conductor, harmonizing frontend and backend elements to build projects that are production ready",
    icon: "icon-globe",
    
  },
  {
    id: 6,
    name: "Contract/referral",
    content: "Hunting for an exceptional developer? With me, you can expect nothing but the utmost reliability and a standard of excellence that sets your project apart ",
    icon: "icon-rocket",
  },

];

function Services() {
  return (
    <div className="row -mt-20">
      {servicesData.map((service) => (
        <div className="col-md-4 col-sm-6 mt-20" key={service.id}>
          <Service service={service} />
        </div>
      ))}
    </div>
  );
}

export default Services;
